<template>
    <rkm-modal
        :loading="loading"
        :buttons="['cancel']"
        :title="`Histórico de saídas (${material.descricaoCompleta})`"
        extra-large
        ref="Modal"
    >
        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    label="Unidade requisitante"
                    v-model="unidadeRequisitante.nomeFantasia"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <rkm-area title="Saídas">
            <rkm-data-table
                :fields="fields"
                :repository="repositories.historico"
                :request-params="datatableRequestParams"
                sort-by="dataRequisicao"
            />
        </rkm-area>
    </rkm-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import { repository } from '@/mixins'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    name: 'requisicao.createdAt',
                    key: 'dataRequisicao',
                    label: 'Data da requisição',
                    class: 'col-min',
                    sortable: true,
                    searchable: true,
                },
                {
                    name: 'requisicao.numero',
                    key: 'numero',
                    label: 'Número',
                    class: 'col-min',
                    sortable: true,
                    searchable: true,
                },
                {
                    name: 'cidadao.nome',
                    key: 'usuarioNome',
                    label: 'Usuário requisitante',
                    sortable: true,
                    searchable: true,
                },
                {
                    name: 'infraestrutura.nome',
                    key: 'infraestruturaNome',
                    label: 'Local de atendimento requisitante',
                    sortable: true,
                    searchable: true,
                },
                {
                    name: 'setor.nome',
                    key: 'setorNome',
                    label: 'Setor requisitante',
                    sortable: true,
                    searchable: true,
                },
                {
                    key: 'concedido',
                    label: 'Concedido',
                    class: 'col-min text-center'
                },
            ]
        },
        datatableRequestParams() {

            return {
                'unidade_requisitante_id': this.unidadeRequisitante.id,
                'material_id': this.material.id,
            }
        }
    },
    created() {

        this.repositories = {
            historico: this.getConectaSusRepository('almoxarifado.requisicaoPendentePermissao.historico')
        }
    },
    data: () => ({
        material: {
            id: null,
            descricaoCompleta: '',
        },
        unidadeRequisitante: {
            id: null,
            nomeFantasia: '',
        },
    }),
    methods: {
        open(item) {

            this.material.id = item.material.id

            this.material.descricaoCompleta = item.material.descricaoCompleta

            this.unidadeRequisitante = item.unidadeRequisitante

            this.$refs.Modal.show()
        }
    },
    mixins: [repository],
}
</script>